import { GetState } from 'zustand';
import { ICountdown } from '../../concepts/countdown';
import { IDocs } from '../../concepts/docs';
import { IGame } from '../../concepts/game';
import { IKpi } from '../../concepts/kpi';
import { ILocations } from '../../concepts/locations';
import { IPlayer } from '../../concepts/player';
import { IToDos, VotingPayload } from '../../concepts/to-dos';
import { IVoting } from '../../concepts/voting';
import { IPhaseExecutorFn } from '../game';

export const startPhase3Voting: IPhaseExecutorFn = (
  get: GetState<
    IGame & IDocs & IToDos & ILocations & IVoting & IPlayer & ICountdown & IKpi
  >
) => {
  get().closeLocation('/');
  get().closeMeeting();
  get().pinLocation('phases/phase-3/vote');
  get().openLocation('phases/phase-3/vote');

  get().clearToDos();
  ToDos.forEach(get().appendToDo);

  get().startVotingSession('phase-3-diagnosis', {
    availableVotes: get().availableDiagnosisVotes(),
    voters: [`DS.${get().team}`],
    isMotivationRequired: true,
  });

  get().startVotingSession('phase-3-distribution', {
    availableVotes: get().availableDirectDistributionVotes(),
    voters: [`DS.${get().team}`],
    isMotivationRequired: true,
  });

  get().startVotingSession('phase-3-tender', {
    availableVotes: get().availableDesertTenderCostsVotes(),
    voters: [`DS.${get().team}`],
    isMotivationRequired: true,
  });

  get().appendToDo<VotingPayload>({
    id: 'vote-phase-3',
    type: 'vote',
    locationToVisit: 'phases/phase-3/vote',
    nudge: '',
    payload: {
      sessions: ['phase-3-diagnosis', 'phase-3-distribution', 'phase-3-tender'],
      gotoPhase: 'phase-3-outcomes',
    },
  });

  get().startCountdown(get().currentPhaseStartTime, 5 * 60 * 1000);
};

const ToDos = [];
